module.exports = __webpack_public_path__ + "static/media/img6.fab1ac56.jpg";